var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"text-center my-5",attrs:{"id":"loading"}},[_c('div',{staticClass:"custom-spinner pull-center mt-2"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }